import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-background flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b px-6 py-3 flex items-center justify-between shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "flex-1 min-h-0 hidden lg:flex" }
const _hoisted_6 = { class: "flex-1 min-h-0 lg:hidden flex flex-col" }

import { ref, provide, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCopilotWidget } from '@/composables/useCopilotWidget'
import { useCopilotStore } from '@/views/Copilot/store'
import { useProjectsStore } from '@/views/Projects/store'
import { useCopilotChat } from '@/views/Copilot/composables/useCopilotChat'
import ContextPanel from '@/views/Copilot/components/ContextPanel.vue'
import CopilotChatPanel from '@/views/Copilot/components/CopilotChatPanel.vue'
import OutputPanel from '@/views/Copilot/components/OutputPanel.vue'

import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { BotMessageSquare, RotateCcw, Minus, X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'CopilotPanel',
  setup(__props) {

const { isOpen, minimize, close } = useCopilotWidget()

const copilotStore = useCopilotStore()
const projectsStore = useProjectsStore()
const { projectContext } = storeToRefs(copilotStore)

// Single shared chat instance
const copilotChat = useCopilotChat()
provide('copilotChat', copilotChat)

const activeTab = ref('chat')

onMounted(async () => {
  if (projectsStore.projects.length === 0) {
    await projectsStore.fetchProjects()
  }
})

const handleNewSession = () => {
  copilotChat.closeSession()
  copilotStore.clearContext()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_unref(isOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(BotMessageSquare), { class: "h-5 w-5" }),
                  _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-lg font-semibold" }, "Copilot", -1)),
                  (_unref(projectContext))
                    ? (_openBlock(), _createBlock(_unref(Badge), {
                        key: 0,
                        variant: "outline"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(projectContext).projectName), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleNewSession
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RotateCcw), { class: "h-3.5 w-3.5 mr-1.5" }),
                      _cache[2] || (_cache[2] = _createTextVNode(" Nueva Sesion ", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    title: "Minimizar",
                    onClick: _unref(minimize)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Minus), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    title: "Cerrar",
                    onClick: _unref(close)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(X), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ContextPanel, { class: "w-[320px] shrink-0 border-r" }),
                _createVNode(CopilotChatPanel, { class: "flex-1" }),
                _createVNode(OutputPanel, { class: "w-[400px] shrink-0 border-l" })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Tabs), {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                  class: "flex-1 flex flex-col"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TabsList), { class: "w-full grid grid-cols-3 shrink-0 rounded-none border-b" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(TabsTrigger), { value: "context" }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Contexto", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "chat" }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Chat", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(TabsTrigger), { value: "output" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Output", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), {
                      value: "context",
                      class: "flex-1 m-0 min-h-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ContextPanel, { class: "h-full" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), {
                      value: "chat",
                      class: "flex-1 m-0 min-h-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CopilotChatPanel)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(TabsContent), {
                      value: "output",
                      class: "flex-1 m-0 min-h-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(OutputPanel)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})